import { useCallback, useRef, useState } from 'react';

export const useAdditionalContactSubmitAttempt = () => {
  const [isAdditionalContactDialogOpen, setIsAdditionalContactDialogOpen] = useState(false);
  const proceedRef = useRef<(() => void) | null>(null);

  const handleInterceptSubmit = useCallback((proceed: () => void) => {
    proceedRef.current = proceed;
    setIsAdditionalContactDialogOpen(true);
  }, []);

  const handleAdditionalContactDialogClose = useCallback(() => {
    setIsAdditionalContactDialogOpen(false);
    const proceed = proceedRef.current;
    proceedRef.current = null;
    proceed?.();
  }, []);

  return {
    handleInterceptSubmit,
    additionalContactDialogProps: {
      open: isAdditionalContactDialogOpen,
      onClose: handleAdditionalContactDialogClose,
    },
  };
};
